<template>
  <div class="function">
    <Back />
    <Car />
    <MainView />
    <transition
      enter-active-class="animated zoomIn"
      leave-active-class="animated zoomOut"
    >
      <div class="roamList" v-if="show">
        <div
          :class="value == index ? 'active list' : 'list'"
          v-for="(item, index) in list"
          :key="index"
          @click="get(index)"
        >
          {{ item }}
        </div>
      </div>
    </transition>
    <img
      src="../assets/roam.png"
      class="roam"
      @click="
        show = !show;
        value = -1;
      "
    />
  </div>
</template>

<script>
import MainView from "../components/MainView.vue";
import Car from "../../common/components/Car1.vue";
import Back from "../components/back.vue";
export default {
  data() {
    return {
      list: ["高层区", "洋房区", "别墅区", "商业区"],
      show: false,
      value: -1,
    };
  },
  components: {
    MainView,
    Car,
    Back,
  },
  methods: {
    get(e) {
      console.log(e);
      this.value = e;
      if (e == 0) {
        document.o2.switch_camera(2674, -184, -3981, 2757, 2970, 5902);
      } else if (e == 1) {
        document.o2.switch_camera(-1559, -803, -4436, -1550, 1916, 6846);
      } else if (e == 2) {
        document.o2.switch_camera(64, -381, -3924, 112, 3945, -8718);
      } else if (e == 3) {
        document.o2.switch_camera(-1098, -464, 1255, -9616, 1551, 1759);
      }
    },
  },
  watch: {
    show(val) {
      console.log(val);
      if (val == false) {
        document.o2.switch_camera(-64, -15, 3, -63, 1012, 4839);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.function {
  width: 100%;
  height: 100%;
  position: relative;
}
.roam {
  position: fixed;
  right: 20px;
  bottom: 40px;
}

.roamList {
  right: 20px;
  bottom: 100px;
  position: fixed;
  .list {
    width: 160px;
    height: 44px;
    background: rgba($color: #fff, $alpha: 1);
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 18px;
    opacity: 0.7;
  }

  .active {
    background: #ffbc1e;
    color: #fff;
    opacity: 1;
    transition: 0.5s;
  }
}
</style>
